import { render, staticRenderFns } from "./SelectedArticles.vue?vue&type=template&id=1f9a7e10&scoped=true"
import script from "./SelectedArticles.vue?vue&type=script&lang=js"
export * from "./SelectedArticles.vue?vue&type=script&lang=js"
import style0 from "./SelectedArticles.vue?vue&type=style&index=0&id=1f9a7e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a7e10",
  null
  
)

export default component.exports